<template>
    <div>
        <div class="row menu-bar mb-0 mb-md-3">
            <div
                v-if="sidebar"
                class="d-none d-md-block col-md-3 p-0 m-0 hide-filters"
                @click="hideSidebar()"
            >
                <img class="lazyload slot-games-filter-icon" :data-src="filterIcon">{{ hideLabelText }}
            </div>
            <div
                v-else
                class="d-none d-md-block col-md-3 p-0 m-0 hide-filters"
                @click="hideSidebar()"
            >
                <img class="lazyload slot-games-filter-icon" :data-src="filterIcon">{{ showLabelText }}
            </div>
            <div class="d-none d-md-block col-md-3 p-0 m-0 filter-items">
                {{ this.filteredSlotGames.length }} ITEM(S)
            </div>
            <div class="col-md-3 p-0 m-0"></div>
            <div class="col-md-3 p-0 m-0 mb-2 mb-md-0 filters-sort-by">
                <sort-by @sort-by-items="getSortBy" :sortOptions="sortOptionsArray"></sort-by>
            </div>
        </div>
        <div class="row" v-if="isLoading">
            <div class="col-12 text-center my-5">
                <div class="spinner-grow text-secondary tex" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>
        <div class="row" v-else>
            <slot-game-filters
                :initial-filters="filters"
                :slot-games="slotGames"
                :filter-icon="filterIcon"
                @input="getFilteredSlotGames"
            ></slot-game-filters>
            <div
                id="Slot-Games"
                class="automation-slot-game slot-games col-md-9 m-0 p-0 body_content_right_col"
                data-inc="GDC - Slot Games List"
            >
                <div v-if="games.length > 0">
                    <div class="gdc-filterable row m-0">
                        <slot-game-item
                            v-for="slotGame in games"
                            :key="slotGame.id"
                            :slotGame="slotGame"
                            :is-free-slot-game="isFreeSlotGames"
                        ></slot-game-item>
                    </div>
                    <div class="ml-2">
                        <pagination
                            :total-pages="gamesPerPage"
                            :total="this.sortedSlotGames.length"
                            :per-page="perPage"
                            :current-page="currentPage"
                            @pagechanged="page => changePage(page)"
                        ></pagination>
                    </div>
                </div>
                <div v-else id="no-results">No Results Found...</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isFreeSlotGames: {
            type: Boolean,
            default: false,
        },
        filterIcon: {
            type: String,
        }
    },
    data() {
        return {
            slotGames: [],
            filteredSlotGames: [],
            filters: [],
            sortedSlotGames: [],
            sortBy: [],
            activeFilters: [],
            perPage: 24,
            currentPage: 1,
            isLoading: true,
            sidebar: true,
            playLabel: '',
            siteFeatureReviewData: [],
            reviewLinksData: [],
            themesData: [],
        };
    },
    mounted() {
        this.getSlotGames();
    },
    computed: {
        endpoint() {
            let geo = this.geo === 'gb' ? '/json-files/' : `/${this.geo}/json-files/`;

            return this.isFreeSlotGames ? `${geo}free-slot-games.json` : `${geo}slot-games.json`;
        },
        games() {
            let toTake = this.perPage * this.currentPage;
            let from = toTake - this.perPage;

            return this.sortedSlotGames.slice(from, toTake);
        },
        gamesPerPage() {
            return Math.ceil(this.sortedSlotGames.length / this.perPage);
        },
        geo() {
            return document.querySelector('[name="geo.region"]').content.toLowerCase();
        },
        hideLabelText() {
            return window.translations.slotGamesList.hide_label || 'HIDE FILTERS';
        },
        showLabelText() {
            return window.translations.slotGamesList.show_label || 'SHOW FILTERS';
        },
        sortOptionsArray() {
            return [
                {
                    value: 'a-z',
                    name: 'sort',
                    label: 'A - Z',
                    locaclisedLabel: window.translations.slotGamesList.sort_a_z || 'A - Z',
                    checked: false,
                },
                {
                    value: 'z-a',
                    name: 'sort',
                    label: 'Z - A',
                    locaclisedLabel: window.translations.slotGamesList.sort_z_a || 'Z - A',
                    checked: false,
                },
                {
                    value: 'new-old',
                    name: 'sort',
                    label: 'Newest - Oldest',
                    locaclisedLabel:
                        window.translations.slotGamesList.sort_date_newest_oldest ||
                        'Newest - Oldest',
                    checked: false,
                },
                {
                    value: 'old-new',
                    name: 'sort',
                    label: 'Oldest - Newest',
                    locaclisedLabel:
                        window.translations.slotGamesList.sort_date_oldest_newest ||
                        'Oldest - Newest',
                    checked: false,
                },
                {
                    value: 'highest-rtp',
                    name: 'sort',
                    label: 'Highest RTP - Lowest RTP',
                    locaclisedLabel:
                        window.translations.slotGamesList.sort_rtp_highest_lowest ||
                        'Highest RTP - Lowest RTP',
                    checked: false,
                },
                {
                    value: 'lowest-rtp',
                    name: 'sort',
                    label: 'Lowest RTP - Highest RTP',
                    locaclisedLabel:
                        window.translations.slotGamesList.sort_rtp_lowest_highest ||
                        'Lowest RTP - Highest RTP',
                    checked: false,
                },
            ];
        },
    },
    methods: {
        /*
         * This function set the current page and scroll window to element SLOT-GAMES
         */
        changePage(page) {
            this.currentPage = page
            this.ktagRerender();
            window.scrollTo({top: window.pageYOffset + document.getElementById('slot-games').getBoundingClientRect().top - 110})
        },
        getSlotGames() {
            fetch(window.location.origin + this.endpoint)
                .then((response) => response.json())
                .then((data) => {
                    this.mapSlotGames(data);
                    this.mapFilters(data);
                    this.isLoading = false;
                    this.$emit('slotgame-is-loading', this.isLoading);
                    this.ktagRerender();
                });
        },
        getFilteredSlotGames(input) {
            this.currentPage = 1;
            this.filteredSlotGames = input;
            this.getSortedSlotGames();
            this.ktagRerender();
        },
        hideSidebar() {
            var sidebar = document.querySelector('#filter-sidebar');
            var slotGames = document.querySelector('#Slot-Games');
            this.sidebar = !this.sidebar;

            if (sidebar.style.display != 'none') {
                sidebar.style.display = 'none';
                slotGames.classList.remove('col-md-9');
            } else {
                sidebar.style.display = 'block';
                slotGames.classList.add('col-md-9');
            }
        },
        getSortBy(sortBy) {
            this.sortBy = sortBy;
            this.getSortedSlotGames();
        },
        getSortedSlotGames() {
            this.sortedSlotGames = JSON.parse(JSON.stringify(this.filteredSlotGames));

            if (this.sortBy.length > 0) {
                this.sortGames();
            }
        },
        sortGames() {
            if (this.sortBy.includes('a-z')) {
                this.sortedSlotGames.sort((a, b) => a.short_title.localeCompare(b.short_title));
            }

            if (this.sortBy.includes('z-a')) {
                this.sortedSlotGames.sort((a, b) => b.short_title.localeCompare(a.short_title));
            }

            if (this.sortBy.includes('lowest-rtp')) {
                this.sortedSlotGames.sort(
                    (a, b) => {
                        return (parseFloat(this.getAttributeValue(a, 181)) || 0) - (parseFloat(this.getAttributeValue(b, 181)) || 0)
                    }
                );
            }

            if (this.sortBy.includes('highest-rtp')) {
                this.sortedSlotGames.sort(
                    (a, b) => {
                        return (parseFloat(this.getAttributeValue(b, 181)) || 0) - (parseFloat(this.getAttributeValue(a, 181)) || 0)
                    }
                );
            }

            if (this.sortBy.includes('old-new')) {
                this.sortedSlotGames.sort(
                    (a, b) =>
                        (this.getAttributeValue(a, 191) || 0) - (this.getAttributeValue(b, 191) || 0)
                );
            }

            if (this.sortBy.includes('new-old')) {
                this.sortedSlotGames.sort(
                    (a, b) =>
                        (this.getAttributeValue(b, 191) || 0) - (this.getAttributeValue(a, 191) || 0)
                );
            }
        },
        mapSlotGames(data) {

            this.siteFeatureReviewData = data.siteFeatureReview;
            this.slotRibbonsData = data.slotRibbons;
            this.reviewLinksData = data.reviewLinks;
            this.imagesData = data.images;
            this.gamesData = data.slotGames;
            this.playLabel = data.playLabel;
            this.attributeTypes = data.attributeTypes;
            this.linkArrowImage = data.linkArrowImage;
            this.playArrowRightImage = data.playArrowRightImage;
            this.oplist = data.oplist;

            let games = data.games.flatMap((item) => {

                let productFeatureId = item.id;
                let review = this.siteFeatureReviewData.find((review) => review.product_feature_id == productFeatureId);
                if (typeof review != 'undefined') {
                    let shortTitle = '';
                    if (this.geo === 'nz') {
                        shortTitle = review.page_name.replace('Slot', 'Pokies').substring(0, 66);
                    } else {
                        shortTitle = review.page_name.substring(0, 66);
                    }

                    let slotRibbonId = item.slot_ribbon_id;
                    if (slotRibbonId != null) {
                        let slotRibbon = this.slotRibbonsData.find((ribbon) => ribbon.id == slotRibbonId);
                        item.slot_ribbon_name = slotRibbon.name;
                    }

                    let reviewLink = this.reviewLinksData.find((reviewLink) => reviewLink.content_id == review.cpk);
                    if (reviewLink) {
                        return {
                            id: review.id,
                            title: review.page_name,
                            short_title: shortTitle,
                            images: {
                                'main': this.imagesData['Feature Review - Main - ' + review.cpk],
                                'next': this.linkArrowImage,
                                'play': this.playArrowRightImage
                            },
                            review_link: reviewLink.path,
                            play_label: this.playLabel,
                            game: item,
                            order: review.order,
                            offer: this.oplist,
                        };
                    } else {
                        return [];
                    }
                } else {
                    return [];
                }
            });

            games = games.sort(function (a, b) {
                return a.order - b.order
            });

            this.slotGames = games;
            this.filteredSlotGames = games;
            this.sortedSlotGames = games;

        },
        mapFilters(data) {
            this.themesData = Object.values(data.themes);
            this.filtersData = Object.values(data.filters);

            this.filtersData.forEach((filter) => {
                if (filter.id === 49 | filter.id === 53) {
                    filter.attributes = this.themesData;
                }
            })

            this.filters = this.filtersData.sort(function (a, b) {
                return a.order - b.order
            });
        },
        getAttributeValue(slotGame, attributeId) {
            let param = slotGame.game.attributes.find((attribute) => attribute.attribute_type_id == attributeId);
            if (typeof param === "undefined") {
                param = {value: 0};
            } else {
                if (param.value === "undefined") {
                    param.value = 0;
                }
            }

            return param.value;
        },
        ktagRerender() {
            setTimeout(() => {
                ktag.reRender()
            }, 500);
        }
    }
};
</script>
